import { forwardRef } from "react";

import {
  isLight,
  UI_CONTRAST_YIQ_THRESHOLD,
} from "../../../../../utils/Color";
import EventCalendarButton from "./event-calendar-button";

const EventHeroCard = forwardRef(
  (
    {
      image,
      imageAlt,
      links = [],
      showCalendarButton,
      primaryColor,
      secondaryColor,
      calendarLabel,
      onCalendarClick,
      textFont,
    },
    ref,
  ) => {
    /* "View More" links use the secondary color; the calendar button below uses
     * the primary color. Fall back to primary if no secondary was provided. */
    const linkColor = secondaryColor || primaryColor;
    /*
     * Business Requirement:
     * OQG3-2598: link label color matches the Design palette pencil
     * (black on a light swatch). The button fill is only a 10% tint, so a
     * dark secondary keeps its own hue rather than flipping to white.
     */
    const linkTextColor = isLight(
      linkColor,
      [],
      UI_CONTRAST_YIQ_THRESHOLD,
    )
      ? "black"
      : linkColor;
    const hasContent = Boolean(image) || links.length > 0 || showCalendarButton;
    if (!hasContent) return null;

    return (
      <div
        ref={ref}
        className="flex flex-col gap-4 p-2 rounded bg-white shadow-[1px_6px_30px_rgba(0,31,14,0.05)]"
        id="company"
      >
        {image && (
          <div className="relative aspect-272/205 w-full overflow-hidden rounded">
            <img
              src={image}
              alt={imageAlt}
              className="absolute inset-0 h-full w-full object-cover"
            />
          </div>
        )}
        {links.map((link, index) => {
          const isLink = link.url && link.url !== "#";
          const inner = (
            <span
              style={{ color: linkTextColor, fontFamily: textFont }}
              className="min-w-0 max-w-full break-words text-center text-xl leading-5.5 font-medium truncate"
            >
              {link.label}
            </span>
          );
          const className =
            "flex min-h-13.5 w-full min-w-0 cursor-pointer items-center justify-center overflow-hidden rounded border p-4";
          const style = {
            backgroundColor: `${linkColor}1A`,
            borderColor: linkColor,
          };

          return isLink ? (
            <a
              key={`link-${index}`}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              style={style}
              className={className}
              id={index === 0 ? "websiteLink" : undefined}
            >
              {inner}
            </a>
          ) : (
            <button
              key={`link-${index}`}
              type="button"
              style={style}
              className={className}
              id={index === 0 ? "websiteLink" : undefined}
            >
              {inner}
            </button>
          );
        })}
        {showCalendarButton && (
          <EventCalendarButton
            primaryColor={primaryColor}
            label={calendarLabel}
            onClick={onCalendarClick}
            textFont={textFont}
          />
        )}
      </div>
    );
  },
);

EventHeroCard.displayName = "EventHeroCard";

export default EventHeroCard;
